interface ISvgSafetyProps {
    height: number | string;
    width: number | string;
    color: string;
}

const SvgSafety: React.FC<ISvgSafetyProps> = (props) => {
    return (
        <svg width={props.width} height={props.height} viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M22.5 2.8125L5.625 8.4375V25.3125C5.625 34.6333 13.1792 42.1875 22.5 42.1875C31.8208 42.1875 39.375 34.6333 39.375 25.3125V8.4375L22.5 2.8125ZM36.2109 25.3125C36.2109 32.8843 30.0718 39.0234 22.5 39.0234C14.9282 39.0234 8.78906 32.8843 8.78906 25.3125V10.8105L22.5 5.97656L36.2109 10.8105V25.3125Z"
                fill={props.color}
            />
            <path
                d="M16.6298 20.8784C16.4832 20.7311 16.3089 20.6142 16.117 20.5345C15.925 20.4547 15.7192 20.4136 15.5114 20.4136C15.3035 20.4136 15.0978 20.4547 14.9058 20.5345C14.7139 20.6142 14.5396 20.7311 14.393 20.8784C14.2457 21.025 14.1288 21.1993 14.049 21.3912C13.9693 21.5832 13.9282 21.789 13.9282 21.9968C13.9282 22.2046 13.9693 22.4104 14.049 22.6024C14.1288 22.7943 14.2457 22.9686 14.393 23.1152L20.0795 28.8017L20.1718 28.894C20.3105 29.0329 20.4752 29.1432 20.6566 29.2184C20.8379 29.2936 21.0324 29.3323 21.2287 29.3323C21.425 29.3323 21.6194 29.2936 21.8008 29.2184C21.9821 29.1432 22.1469 29.0329 22.2856 28.894L32.1074 19.0723C32.2463 18.9336 32.3566 18.7688 32.4318 18.5875C32.507 18.4061 32.5457 18.2117 32.5457 18.0154C32.5457 17.819 32.507 17.6246 32.4318 17.4433C32.3566 17.2619 32.2463 17.0972 32.1074 16.9585L31.9843 16.8354C31.8456 16.6965 31.6809 16.5862 31.4995 16.511C31.3182 16.4358 31.1238 16.3971 30.9275 16.3971C30.7311 16.3971 30.5367 16.4358 30.3554 16.511C30.174 16.5862 30.0093 16.6965 29.8706 16.8354L21.2265 25.4751L16.6298 20.8784Z"
                fill={props.color}
            />
        </svg>
    );
};

export default SvgSafety;
